import { useMemo } from "react";
import { useOptionsVisibility } from "./useOptionsVisibility";
const useComboboxOptions = ({
  options,
  schemaForm,
  rules,
  preview
}) => {
  const optionVisibilities = useOptionsVisibility({
    options,
    schemaForm,
    rules,
    preview
  });
  const allOptionsTransformed = useMemo(
    () => options.map((option) => ({
      dsId: `${option.id}`,
      type: "option",
      label: `${option.text}`,
      value: `${option.value}`,
      default: option.default
    })),
    [options]
  );
  const visibleOptions = useMemo(
    () => allOptionsTransformed.filter(
      (_option, idx) => optionVisibilities[idx] ?? options[idx]?.visible
    ),
    [allOptionsTransformed, options, optionVisibilities]
  );
  return { allOptionsTransformed, visibleOptions };
};
export {
  useComboboxOptions
};
